export function LeftArrowIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21px" height="21px" viewBox="0 0 408 408">
      <path fill="#fff" d="M408,178.5H96.9L239.7,35.7L204,0L0,204l204,204l35.7-35.7L96.9,229.5H408V178.5z" />
    </svg>
  );
}
